import {Modal} from 'react-bootstrap'
import ModalHeader from 'components/Modal/ModalHeader'
import {connect} from 'react-redux'
import {getFormValues, reduxForm, Field, formValueSelector, initialize, change} from 'redux-form'
import {
  cancelAddIngredientsModal,
  addIngredientsOnSearchModal,
  addIngredientsOnChangeSelectModal,
  addIngredientRecipesDetail,
  addIngredientsGetingredientRequest
} from 'actions/ingredients/recipes'
import styles from './AddItemsModal.css'
import 'react-select/dist/react-select.css'
import validator from 'validator'
import {currencyFormatter} from 'utils/formatter'
import SearchModal from 'components/Fields/ReduxForm/SearchModal'
import SettingField from 'components/Fields/ReduxForm/SettingField'

const normalizeNumber = (value = 0, previousValue) => {
  if (value === '') {
    return value
  } else {
    if (!isNaN(value)) {
      return value
    } else {
      return previousValue
    }
  }
}

const validate = (values, props) => {
  const errors = {}
  const itemsErrors = []
  if (values.items) {
    values.items.forEach((member, index) => {
      const memberErrors = {}
      if (!member.quantity && '' + member.quantity !== '0') {
        memberErrors.quantity = 'Please enter a value'
        itemsErrors[index] = memberErrors
      } else if (!validator.isNumeric(member.quantity + '')) {
        memberErrors.quantity = 'Please enter a valid Number'
        itemsErrors[index] = memberErrors
      } else if (parseFloat(member.quantity) - 999999 > 0.000001) {
        memberErrors.quantity = 'Quantity must be less than 999999'
        itemsErrors[index] = memberErrors
      }
    })
  }
  if (itemsErrors.length) {
    errors.items = itemsErrors
  }
  return errors
}

class AddItemsModal extends React.Component {
  render () {
    let {showAddItemsModal, addIngredients, addIngredientsForm} = this.props
    let options
    let disableBtn
    if (!addIngredientsForm) {
      disableBtn = true
    } else {
      if (addIngredientsForm.ingredient_id === undefined) {
        disableBtn = true
      } else {
        disableBtn = false
      }
    }
    if (addIngredients.ingredients.results) {
      options = addIngredients.ingredients.results.map((ingredient) => {
        return {value: ingredient.id, label: ingredient.name}
      })
    } else {
      options = []
    }
    return (
      <Modal show={showAddItemsModal} backdrop='static' dialogClassName={styles.dialog}>
        <ModalHeader title={this._title()} />
        <form onSubmit={this._onSubmit.bind(this, addIngredientsForm)}>
          <Modal.Body className={styles.modalBody}>
            <Field
              component={SearchModal}
              type='text'
              name='search-item'
              placeholder={this._selectPlaceholder()}
              options={options}
              onClickItem={this._onChangeSelect}
              onInputChange={this._onChangeKeyword}
              inputValue={addIngredients.ingredient ? addIngredients.ingredient.id : null}
              onMenuScrollToBottom={this._onSearchReachBottom}
              isHasMore={this._hasMore}
              isLoading={addIngredients.isLoading}
            />
            <div className='mt-10px'>
              {addIngredients.ingredient && <table className={`${styles['table-header']} table table-truncate`}>
                <thead>
                  <tr>
                    <th className='text-center' width='25%'>Ingredient</th>
                    <th className='text-center' width='25%'>Quantity</th>
                    <th className='text-center' width='25%'>Unit</th>
                    <th className='text-center' width='25%'>Avg Cost</th>
                  </tr>
                </thead>
                <tbody />
              </table>}
              {addIngredients.ingredient && this._renderIngredientFields()}
            </div>
          </Modal.Body>
          <Modal.Footer>
            <span className='pull-left'>
              <button className='btn btn-default' onClick={this._onHide}>
                Cancel
              </button>
            </span>
            <span className='pull-right'>
              <button className={disableBtn ? `btn ${styles['disableBtnAddItem']}` : 'btn btn-primary'} disabled={disableBtn} onClick={this._onSubmit.bind(this, addIngredientsForm)}>
                Add
              </button>
            </span>
          </Modal.Footer>
        </form>
      </Modal>
    )
  }

  _onSubmit = (values, e) => {
    const {addIngredients: {ingredient}, dispatch, recipesForm} = this.props
    // kalo gak ada item yang diselect, don't do anything
    if (ingredient) {
      dispatch(addIngredientRecipesDetail(values, recipesForm))
    }
    e.preventDefault()
    e.stopPropagation()
  }

  _onOpen = () => {
    this.props.dispatch(initialize('addIngredients', {}))
  }

  _onChangeSelect = (dropdownVal) => {
    const {addIngredients: {ingredients}, dispatch, recipesForm} = this.props
    let selected = null
    ingredients.results.forEach((i, index) => {
      if (dropdownVal.value === i.id) {
        selected = ingredients.results[index]
      }
    })
    if (selected) {
      dispatch(addIngredientsOnChangeSelectModal(selected, recipesForm))
    }
  }

  _onChangeKeyword = (value) => {
    const {dispatch} = this.props
    dispatch(addIngredientsOnSearchModal(value))
  }
  _onSearchReachBottom = () => {
    const {addIngredients: {ingredients: {currentPage, total_pages: total, results}, keyword}, dispatch} = this.props
    if (total > currentPage) {
      dispatch(addIngredientsGetingredientRequest({
        page: currentPage + 1,
        per_page: 100,
        no_categories: true,
        keyword,
        previousItems: results
      }))
    }
  }
  _hasMore = () => {
    const {addIngredients: {ingredients: {currentPage, totalPage}}} = this.props
    return currentPage < totalPage
  }

  _onHide = (event) => {
    const {dispatch} = this.props
    dispatch(cancelAddIngredientsModal())
  }

  _title = () => {
    return 'Add Ingredient'
  }

  _selectPlaceholder = () => {
    return 'Search Ingredients'
  }

  _renderIngredientFields = () => {
    let {addIngredients: {ingredient}} = this.props
    return <div className='mk-grouped-list-input'>
      <div className='mk-grouped-input'>
        <div className='form-group col-sm-3'>
          <Field
            name='ingredient_id'
            component='input'
            readOnly
            className={`form-control hidden`}
            type='hidden'
            disabled
          />
          <Field
            name='ingredient_name'
            component='input'
            className={`form-control`}
            placeholder='Ingredient Name'
            disabled
          />
        </div>
        <div className='form-group col-sm-3'>
          <Field
            component={SettingField}
            positiveNumberOnly
            maxFractionDigits={2}
            name='quantity'
            className={`form-control`}
            placeholder='0.00'
            normalize={normalizeNumber}
            onChange={(event, value) => {
              let quantity = parseFloat(value)
              quantity = !isNaN(quantity) ? quantity : null
              this.props.dispatch(change('addIngredients', `quantity`, quantity))
              if (ingredient && ingredient.track_cogs) {
                this.props.dispatch(change('addIngredients', `ingredient_avg`, ingredient.cogs * quantity))
              }
              return value
            }}
          />
        </div>
        <div className='form-group col-sm-3'>
          <Field
            name='unit_name'
            component='input'
            placeholder='Unit Name'
            className={`form-control`}
            disabled
          />
        </div>
        <div className='form-group col-sm-3'>
          <Field
            name='ingredient_avg'
            component='input'
            disabled
            placeholder={ingredient && ingredient.track_cogs ? 'Rp. 0' : ''}
            className={`form-control`}
            format={ingredient && ingredient.track_cogs ? (value) => currencyFormatter(value) : ''}
            // prevent default behavior because this field will trigger reducer change on on the redux
            onFocus={(e) => { e.preventDefault() }}
            onBlur={(e) => { e.preventDefault() }}
          />
        </div>
      </div>
    </div>
  }
}

formValueSelector('addIngredients')

function mapStateToProps (state) {
  const {showAddItemsModal, addIngredients, outlets} = state.ingredients.recipes
  return {
    showAddItemsModal,
    addIngredients,
    outlets,
    recipesForm: getFormValues('recipes')(state),
    search: getFormValues('search')(state),
    addIngredientsForm: getFormValues('addIngredients')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {dispatch}
}

const mapForm = {
  form: 'addIngredients',
  validate,
  touchOnBlur: false,
  touchOnChange: false,
  touchOnValidate: false
}
export default reduxForm(mapForm)(connect(mapStateToProps, mapDispatchToProps)(AddItemsModal))



// WEBPACK FOOTER //
// ./app/pages/Ingredient/Recipes/RecipesDetail/AddItemsModal/AddItemsModal.js